export const baseConf = {
  thirdPartyConfig: {
    googleTagManager: {
      id: 'GTM-TNL2F7CJ',
      layer: 'dataLayer',
    },
    fullStory: {
      host: 'fullstory.com',
      script: 'edge.fullstory.com/s/fs.js',
      orgId: '', // TODO: Only use on prod
    },
    transcend: {
      id: '6beaafdb-ad13-4a71-bbf9-467debfba53d',
    },
  },
  tracking: {
    felog: {
      url: 'https://f-log-at.grammarly.io',
    },
    femetrics: {
      url: 'https://website.femetrics.grammarly.io/batch/import',
    },
    shLegacyTracking: {
      apiUrl: 'https://mail.staging-superhuman.com/~backend/v3/metrics.write',
      enabled: false,
    },
  },
  paths: {
    basePath: 'https://qa-sh.io',
    signIn: '/signin',
    plans: '/plans',
    upgradePro: '/upgrade/superhuman/pro',
    upgradeBusiness: '/upgrade/superhuman/business',
    earlyAccess: '/contact/early-access',
    agentStore: 'https://staging-superhuman.com/store/agents',
    goIntro: '/superhuman-go-intro',
    coda: {
      onboarding: '/onboarding',
    },
    grammarly: {
      personalize: '/personalize',
    },
    nomos: {
      basePath: 'https://settings.qa-sh.io',
      atc: '/apps',
    },
    mail: {
      basePath: 'https://mail.staging-superhuman.com',
      landing: 'https://staging-superhuman.com/products/mail',
    },
  },
  products: {
    go: {
      paths: {
        onboarding: '/superhuman-go-intro',
      },
      extension: {
        chrome: {
          downloadUrl:
            'https://chromewebstore.google.com/detail/grammarly-grammar-checker/kbfnbcaeplbcioakkpcpgfkobkghlhen',
          downloadDomain: 'chromewebstore.google.com',
          downloadPath: '/detail/grammarly-grammar-checker/kbfnbcaeplbcioakkpcpgfkobkghlhen',
        },
        edge: {
          downloadUrl:
            'https://microsoftedge.microsoft.com/addons/detail/cnlefmmeadmemmdciolhbnfeacpdfbkd',
          downloadDomain: 'microsoftedge.microsoft.com',
          downloadPath: '/addons/detail/cnlefmmeadmemmdciolhbnfeacpdfbkd',
        },
      },
    },
    mail: {
      appDownloadUrl: 'https://superhuman.com/download',
      extension: {
        chrome: {
          downloadUrl:
            'https://chromewebstore.google.com/detail/superhuman/dcgcnpooblobhncpnddnhoendgbnglpn',
        },
      },
    },
  },
} as const
